document.addEventListener("DOMContentLoaded", function () {
  const searchAction = document.querySelector('.js-searchmodule--action');
  const searchKeyword = document.querySelector('.js-searchmodule--keyword');

  const pageUrl = window.location.href.replace(location.search, "");

  if (searchAction && searchKeyword) {
    searchAction.addEventListener('click', function () {
      if (searchKeyword.value && searchKeyword.value.length > 0) {
        window.location.assign(`${pageUrl}?keyword=${searchKeyword.value}`);
      }
    });

    searchKeyword.addEventListener('keydown', function (e) {
      if (e.keyCode == 13) {
        if (searchKeyword.value && searchKeyword.value.length > 0) {
          window.location.assign(`${pageUrl}?keyword=${searchKeyword.value}`);
        }
      }
    });
  }
});